// CA-14 Natulim DB 07/07/2026 — Copiado de PL (natulim/master): componente JUO Build-a-Box. Mensajes de error traducidos PL→PT.
(function () {
  function initAddSetBtn() {
    const btn = document.querySelector('.juo-add-set-btn');
    if (!btn) return;

    btn.addEventListener('click', function () {
      const dataEl = document.getElementById('juo-box-data');
      if (!dataEl) return;
      let boxData;
      try { boxData = JSON.parse(dataEl.textContent); } catch (e) { return; }

      const items = [];
      let totalQty = 0;

      const parentId = boxData.product && boxData.product.id;
      const parentHandle = boxData.product && boxData.product.handle;
      const boxProps = {
        _box: 'box-' + parentId,
        _parent_product_handle: String(parentHandle),
        _parent_product_id: String(parentId)
      };

      // Always add 1 of each product from the box definition
      if (boxData.products && boxData.products.length > 0) {
        boxData.products.forEach(function (product) {
          if (!product.variants || !product.variants.length) return;
          let variant = null;
          for (let i = 0; i < product.variants.length; i++) {
            if (product.variants[i].available !== false) { variant = product.variants[i]; break; }
          }
          if (!variant) variant = product.variants[0];
          if (!variant) return;
          items.push({ id: variant.id, quantity: 1, properties: boxProps });
          totalQty += 1;
        });
      }

      if (items.length === 0) return;

      // Add free product if threshold met
      const fp = boxData.freeProduct;
      if (fp && fp.id != null && boxData.freeProductFrom > 0 && totalQty >= boxData.freeProductFrom) {
        items.push({ id: fp.id, quantity: 1, properties: { _box: 'box-' + parentId, _parent_product_handle: String(parentHandle) } });
      }

      btn.disabled = true;
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const cartDrawer = document.querySelector('cart-drawer');
      const sections = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
        ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
        : [];

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        btn.disabled = false;
        document.dispatchEvent(new CustomEvent('juo-box:cart:added'));
        document.dispatchEvent(new Event('reload-side-cart'));
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(data);
        } else {
          const cartIconBtn = document.querySelector('#cart-icon-bubble');
          if (cartIconBtn) cartIconBtn.click();
        }
      })
      .catch(function () { btn.disabled = false; });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAddSetBtn);
  } else {
    initAddSetBtn();
  }
})();
